import { ChangeEvent, Fragment } from "react";

import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import { Loader } from "../../../UI/Loaders/Loaders";
import { useDispatch } from "react-redux";
import moment from "moment";
import { showModal } from "../../../redux/actions/modal";
import useAllAdminUsers from "../../../custom-hooks/useAllAdminUsers";
import useAllRoles from "../../../custom-hooks/useAllRoles";
import { useState } from "react";
import {
  postDataWithDotNet,
  putDataWithDotNet,
} from "../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { errorHandler } from "../../../helpers/errorHandler";
import Paginator from "../../Pagination/Pagination.component";
import { appInsights } from "../../../config/appInsights";

type TAddUser = {
  password: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  roleIds: number[];
};

const ManageAdminUsers = () => {
  const [loading, setLoading] = useState<null | string>(null);
  const [success, setSuccess] = useState<null | string>(null);
  const [error, setError] = useState<null | string>(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [count, setCount] = useState(null);
  const [size, setSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [roleId, setRoleId] = useState(0);
  const [roleName, setRoleName] = useState("Super Admin");
  const [searchByEmailQuery, setSearchByEmailQuery] = useState("");

  const dispatch = useDispatch();

  const {
    data,
    error: dataError,
    status,
  } = useAllAdminUsers({
    role_id: roleId.toString(),
    Page: pageNumber.toString(),
    PageSize: size.toString(),
    search_value: searchByEmailQuery,
  });

  const {
    data: rolesData,
    error: rolesError,
    status: rolesStatus,
  } = useAllRoles();
  //  Methods
  const modalHandler = (modalData: any) => {
    dispatch(
      showModal({
        modalIdentifier: "createuser",
        dataRecord: modalData,
        action: "customrange",
      })
    );
  };

  const updateUser = async (reqBody: any) => {
    setLoading("Updating User...");
    setError(null);
    try {
      await putDataWithDotNet(ajaxEndpoints.MANAGE_ADMIN_USER, reqBody);
      setLoading(null);
      setSuccess("User has been updated.");

      setTimeout(() => {
        setSuccess(null);
      }, 3000);
    } catch (error: any) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "ManageAdminUsers.component.jsx",
        },
      });
      setLoading(null);
      setError(errorHandler(error));
      setTimeout(() => {
        setError(null);
      }, 3000);
    }
  };

  const addUser = async (reqBody: TAddUser) => {
    setLoading("Adding new user...");
    setError(null);
    try {
      await postDataWithDotNet(ajaxEndpoints.MANAGE_ADMIN_USER, reqBody);
      setLoading(null);
      setSuccess("New user has been added.");
      setTimeout(() => {
        setSuccess(null);
      }, 3000);
    } catch (error: any) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "ManageAdminUsers.component.jsx",
        },
      });
      setLoading(null);
      // setError(errorHandler(error));
      setError(error?.response?.data?.data[0]);
      setTimeout(() => {
        setError(null);
      }, 3000);
    }
  };

  const updateUserRoles = async (reqBody: any) => {
    setLoading("Updating user roles...");
    setError(null);
    try {
      await postDataWithDotNet(ajaxEndpoints.ASSIGN_ROLE, reqBody);
      setLoading(null);
      setSuccess("New roles have been added to this user.");
      setTimeout(() => {
        setSuccess(null);
      }, 3000);
    } catch (error: any) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "ManageAdminUsers.component.jsx",
        },
      });
      setLoading(null);
      setError(
        "An error occured while updating the roles assigned to this user."
      );
      setTimeout(() => {
        setError(null);
      }, 3000);
    }
  };

  if (data) {
    if (count === null) {
      setCount(data?.totalCount);
    }
  }

  const resetTable = () => {
    setCount(null);
    setPageNumber(1);
  };

  //JSX Template
  let RenderedComponent = null;
  if (
    (!data && status !== "loading") ||
    (!rolesData && rolesStatus !== "loading")
  ) {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch users who have{" "}
            {roleName} roles
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading" || rolesStatus === "loading") {
    RenderedComponent = <Loader centered="true" text="Loading users" />;
  } else if (loading) {
    RenderedComponent = <Loader centered="true" text={loading} />;
  } else if (error) {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt p-y-5">
            <i className="fas fa-bell" /> {error}
          </h4>
        </div>
      </div>
    );
  } else {
    if (rolesError || dataError) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              users who have {roleName} role, Please Reload The Page.
            </h4>
          </div>
        </div>
      );
    } else if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> {error}
            </h4>
          </div>
        </div>
      );
    } else if (success) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> {success}
            </h4>
          </div>
        </div>
      );
    } else if (data && data?.data.length === 0) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no users who
              have {roleName} roles
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="grid__padding animated fadeInRight">
          <MDBTable responsive minimal="true" bordered hover>
            <MDBTableHead>
              <tr>
                <th>S/N</th>
                <th>Email</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>User Type</th>
                <th>Phone Number</th>
                <th>Date Joined</th>
                <th colSpan={2}>Last Login</th>
                <th>Manage</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {data &&
                data?.data?.length &&
                data?.data.map((user: any, _id: number) => {
                  const {
                    email,
                    user_type,
                    date_joined,
                    first_name,
                    last_name,
                    last_login,
                    phone,
                  } = user;
                  return (
                    <tr key={_id}>
                      <td>{_id + 1}</td>
                      <td>{email}</td>
                      <td>{first_name}</td>
                      <td>{last_name}</td>
                      <td>{user_type}</td>
                      <td>{phone}</td>
                      <td>{moment(date_joined).format("llll")}</td>
                      <td colSpan={2}>{moment(last_login).format("llll")}</td>
                      <td className="space-items">
                        <div className="dropdown">
                          <button
                            className="btn zoom-element btn-slim dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          ></button>
                          <div
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <span
                              className="cursor-pointer dropdown-item"
                              onClick={() => {
                                modalHandler({
                                  type: "view_user",
                                  user,
                                });
                              }}
                            >
                              VIEW
                            </span>
                            <span
                              className="cursor-pointer dropdown-item"
                              onClick={() => {
                                modalHandler({
                                  type: "update_user",
                                  user,
                                  action: updateUser,
                                });
                              }}
                            >
                              UPDATE
                            </span>
                            <span
                              className="cursor-pointer dropdown-item"
                              onClick={() => {
                                modalHandler({
                                  type: "update_user_role",
                                  data: {
                                    rolesData,
                                    user,
                                  },
                                  action: updateUserRoles,
                                });
                              }}
                            >
                              UPDATE ROLE(S)
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </MDBTableBody>
          </MDBTable>
          <Paginator
            size={size}
            page={pageNumber}
            count={count}
            changeCurrentPage={(pageNumber: any) => setPageNumber(pageNumber)}
          />
        </div>
      );
    }
  }

  return (
    <Fragment>
      <div className="row animated fadeInRight m-x-1 m-t-1 m-b-2">
        <div className="col-lg-12 col-md-12 col-sm-12 text-right">
          <button
            className="create zoom-element btn login-btn "
            onClick={() => {
              modalHandler({
                type: "add_user",
                rolesData,
                action: addUser,
              });
            }}
          >
            <i className="fas fa-user-plus" /> &nbsp; Create User
          </button>
        </div>
      </div>
      <div className="row animated fadeInRight m-x-1 m-t-1 m-b-2">
        <div className="col-lg-4 col-md-6 col-sm-12">
          <div>
            <label htmlFor="table-fetch" className="form-group">
              Showing results for:{" "}
              <select
                onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                  // if (!e.target.value) return;
                  setRoleId(Number(e.target.value));
                  const role = rolesData.find(
                    (role: any) =>
                      Number(role.id) === Number(e.target.value) && role
                  );

                  setRoleName(!role ? "All" : role.name);
                  resetTable();
                }}
                id="table-fetch"
                className="table-fetch-select"
                style={{ maxWidth: "200px", minWidth: "200px" }}
              >
                <option value={0}>All</option>
                {rolesData &&
                  rolesData.length &&
                  rolesData.map((role: any) => {
                    const { name, id } = role;
                    return (
                      <option value={id} key={id}>
                        {name}
                      </option>
                    );
                  })}
              </select>
            </label>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <div className="d-flex flex-row flex-wrap justify-content-start">
            <label htmlFor="table-fetch" className="form-group">
              Number of results:{" "}
              <select
                onChange={(e) => {
                  setSize(Number(e.target.value));
                  resetTable();
                }}
                id="table-fetch"
                className="table-fetch-select m-l-1"
                value={size}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </label>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
          <input
            className="form-control mr-3"
            type="text"
            placeholder="Search user by email"
            aria-label="Search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          ></input>
          <button
            className="btn m-0 login-btn"
            style={{ height: "2.2rem" }}
            onClick={() => setSearchByEmailQuery(searchValue)}
          >
            Search
          </button>
        </div>
      </div>
      {RenderedComponent}
    </Fragment>
  );
};

export default ManageAdminUsers;
